import { Component, HostListener } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import emailjs, { type EmailJSResponseStatus } from '@emailjs/browser';

@Component({
  selector: 'app-home-thirteen',
  templateUrl: './home-thirteen.component.html',
  styleUrl: './home-thirteen.component.css'
})
export class HomeThirteenComponent {
  // OWl Slider
  customOptions: OwlOptions = {
    loop: true,
    dots: true,
    margin:0,
    nav:false,
    autoplay:false,
    autoplaySpeed: 2000,
    navSpeed: 2000,
    items: 1,
    navText: ['<i class="icofont icofont-arrow-left"></i>', '<i class="icofont icofont-arrow-right"></i>'],
  }

  slideStore = [
    {
      introtext: "The Power of Knowledge",
      title: "Learning Never Stops",
      subtitle: "Explore, Discover, Grow",
      image: "assets/images/slides/home-bg-26.jpg",
      btnSlide: "btn btn-md btn-purple btn-rounded mt-30",
      btnText: "Get Started",
    },

    {
      introtext: "Learning Never Stops",
      title: "The Power of Knowledge",
      image: "assets/images/slides/home-bg-27.jpg",
      btnSlide: "btn btn-md btn-purple btn-rounded mt-30",
      btnText: "Get Started",
    },

    {
      introtext: "Unlocking the Power Within",
      title: "Ignite Your Passion for Learning",
      image: "assets/images/slides/home-bg-28.jpg",
      btnSlide: "btn btn-md btn-purple btn-rounded mt-30",
      btnText: "Get Started",
    }

  ]

  // Skills
  skills = [
    { name: 'Education', level: 90 },
  ];

  isScrolled = false;

  @HostListener('window:scroll', [])
  onScroll(): void {
    const skillsSection = document.querySelector('.skill');
    
    // Add a null check for skillsSection
    if (skillsSection) {
      const position = skillsSection.getBoundingClientRect().top;
      const windowHeight = window.innerHeight;

      // Check if the section is in view
      if (position < windowHeight) {
        this.isScrolled = true;
      }
    }
  }

  // Features
  features =[
    {
      featureBox: "feature-box text-center xs-mb-30 feature-box-solid center-feature border-radius-10",
      icon: "fa fa-thumbs-up font-20px icon-bg purple-color",
      title: "Relaxing & Learning",
      desc:"Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
    },
    {
      featureBox: "feature-box text-center xs-mb-30 feature-box-solid center-feature border-radius-10",
      icon: "fa fa-certificate font-20px icon-bg purple-color",
      title: "Certificate",
      desc:"Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
    },
    {
      featureBox: "feature-box text-center xs-mb-30 feature-box-solid center-feature border-radius-10",
      icon: "fa fa-laptop font-20px icon-bg purple-color",
      title: "Private Mentoring",
      desc:"Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
    },
    {
      featureBox: "feature-box text-center xs-mb-30 feature-box-solid center-feature border-radius-10",
      icon: "fa fa-tint font-20px icon-bg purple-color",
      title: "Creative Thinking",
      desc:"Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
    }
  ]

  // Funfacts
  funFacts =[
    {
      icon: "fa fa-code dark-color font-50px",
      number: 8885,
      desc: "Lines of Code",
      displayedNumber: 0
    },
    {
      icon: "fa fa-trophy dark-color font-50px",
      number: 92,
      desc: "Awards",
      displayedNumber: 0
    },
    {
      icon: "fa fa-coffee dark-color font-50px",
      number: 1099,
      desc: "Cups of Coffee",
      displayedNumber: 0
    },
    {
      icon: "fa fa-anchor dark-color font-50px",
      number: 576,
      desc: "Projects Won",
      displayedNumber: 0
    }
  ]

  ngOnInit(): void {
    this.startCounters();
  }

  startCounters(): void {
    this.funFacts.forEach(fact => {
      this.animateCounter(fact);
    });
  }

  animateCounter(fact: any): void {
    const duration = 4000; 
    const intervalTime = 50; 
    const increment = fact.number / (duration / intervalTime);

    const interval = setInterval(() => {
      fact.displayedNumber += increment;
      if (fact.displayedNumber >= fact.number) {
        fact.displayedNumber = fact.number;
        clearInterval(interval); 
      }
    }, intervalTime);
  }

  // Owl Slider Team
  customOptionsTwo: OwlOptions = {
    loop: true,
    dots: true,
    margin: 30,
    nav: false,
    autoplay: true,
    autoplaySpeed: 2000,
    navSpeed: 2000,
    items: 3,
    navText: ['', ''],
    responsive:{
      0:{
          items:1,
      },
      600:{
          items:2,
      },
      1000:{
          items:3,
      }
    }
  };

  slideStoreTwo: { title: string; subtitle: string; image: string; index: number }[] = [
    {
      title: "Science Teacher",
      subtitle: "Ramon Gibson",
      image: "team-9.jpg",
      index: 0
    },
    {
      title: "Math Specialist",
      subtitle: "Megan Cade",
      image: "team-10.jpg",
      index: 1
    },
    {
      title: "Assistant Teacher",
      subtitle: "Paul Phelan",
      image: "team-11.jpg",
      index: 2
    }
  ];

  socialLinks = [
    { iconOuter: "facebook", iconInner: ['fa-brands fa-facebook'] },
    { iconOuter: "twitter", iconInner: ['fa-brands fa-x-twitter'] },
    { iconOuter: "pinterest", iconInner: ['fa-brands fa-pinterest'] },
  ];

  // Services
  services = [
    {
      icon: "fa fa-laptop font-20px purple-color",
      title: "Art & Design",
      desc: "10+ Courses",
    },
    {
      icon: "fa fa-globe font-20px purple-color",
      title: "Web Development",
      desc: "10+ Courses",
    },
    {
      icon: "fa fa-bar-chart font-20px purple-color",
      title: "Digital Marketing",
      desc: "10+ Courses",
    },
    {
      icon: "fa fa-code font-20px purple-color",
      title: "HTML CSS",
      desc: "10+ Courses",
    },
    {
      icon: "fa fa-inbox font-20px purple-color",
      title: "Leadership",
      desc: "10+ Courses",
    },
    {
      icon: "fa fa-bomb font-20px purple-color",
      title: "Data Science",
      desc: "10+ Courses",
    },
    {
      icon: "fa fa-comment font-20px purple-color",
      title: "ChatGPT",
      desc: "10+ Courses",
    },
    {
      icon: "fa fa-book font-20px purple-color",
      title: "Deep Learning",
      desc: "10+ Courses",
    },
  ]

  // Portfolio
  portfolios = [
    {
      img: "1.jpg",
      title: "Fode ",
      subTitle: "Branding, Mockup"
    },
    {
      img: "2.jpg",
      title: "Daniel and Denise",
      subTitle: "Branding, UI/UX"
    },
    {
      img: "3.jpg",
      title: "Sydney Design",
      subTitle: "Design, Stationery"
    },
    {
      img: "4.jpg",
      title: "Glasses",
      subTitle: "Branding, UI/UX"
    },
    {
      img: "5.jpg",
      title: "The Bijou Factory",
      subTitle: "Branding, Mockup"
    },
    {
      img: "6.jpg",
      title: "Calender",
      subTitle: "Design, Branding"
    },
    {
      img: "7.jpg",
      title: "Flyer",
      subTitle: "Branding, Stationery"
    },
    {
      img: "8.jpg",
      title: "Hand Watch",
      subTitle: "Design, UI/UX"
    }
  ]

  // Video Popup
	isOpen = false;
  openPopup(): void {
      this.isOpen = true;
  }
  closePopup(): void {
      this.isOpen = false;
  }

  // Pricing
  pricing = [
    {
      title: "Basic Plan",
      subTitle: "An affordable option for end-to-end hiring at small companies.",
      currency: "$",
      amount: 9.99,
      btnClass: "btn btn-dark btn-md btn-default btn-rounded",
      btnText: "Get Started",
      features: [
        'Mobile-Optimized Website',
        'Powerful Website Metrics',
        'Free Custom Domain',
        '24/7 Customer Support',
        'Fully Integrated E-Commerce',
        'Sell Unlimited Products &amp; Accept Donations',
        'No CMS items',
        'No site search',
        'No CMS API access',
        'No content editors'
      ]
    },

    {
      title: "Standard Plan",
      subTitle: "An affordable option for end-to-end hiring at small companies.",
      currency: "$",
      amount: 16.99,
      btnClass: "btn btn-dark btn-md btn-default btn-rounded",
      btnText: "Get Started",
      features: [
        'Mobile-Optimized Website',
        'Powerful Website Metrics',
        'Free Custom Domain',
        '24/7 Customer Support',
        'Fully Integrated E-Commerce',
        'Sell Unlimited Products &amp; Accept Donations',
        'No CMS items',
        'No site search',
        'No CMS API access',
        'No content editors'
      ]
    },

    {
      title: "Extended Plan",
      subTitle: "An affordable option for end-to-end hiring at small companies.",
      currency: "$",
      amount: 24.99,
      btnClass: "btn btn-dark btn-md btn-default btn-rounded",
      btnText: "Get Started",
      features: [
        'Mobile-Optimized Website',
        'Powerful Website Metrics',
        'Free Custom Domain',
        '24/7 Customer Support',
        'Fully Integrated E-Commerce',
        'Sell Unlimited Products &amp; Accept Donations',
        'No CMS items',
        'No site search',
        'No CMS API access',
        'No content editors'
      ]
    }
  ];

  // Owl Testimonial
  customOptionsThree: OwlOptions = {
    loop: true,
    dots: true,
    margin:30,
    nav:true,
    autoplay:true,
    autoplaySpeed: 2000,
    navSpeed: 2000,
    items: 3,
    navText: ['<i class="icofont icofont-arrow-left"></i>', '<i class="icofont icofont-arrow-right"></i>'],
    responsive:{
      0:{
          items:1,
      },
      600:{
          items:2,
      },
      1000:{
          items:3,
      }
    }
  }

  slideStoreThree = [
    {
      title: "Anne McAdams",
      subTitle: "CEO / Founder",
      description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec sodales nec nulla ac aliquet. Duis vel nunc eget.",
      image: "assets/images/team/avatar-1.jpg",
    },

    {
      title: "Jared Kane",
      subTitle: "CEO / Founder",
      description: "Quisque hendrerit turpis sit amet tortor condimentum, nec commodo lorem condimentum. Sed id diam efficitur, mattis tellus ac, malesuada purus. In ultrices nisl sed eleifend consequat.",
      image: "assets/images/team/avatar-2.jpg",
    },

    {
      title: "Nani Wale",
      subTitle: "CEO / Founder",
      description: "Quisque hendrerit turpis sit amet tortor condimentum, nec commodo lorem condimentum. Sed id diam efficitur, mattis tellus ac, malesuada purus. In ultrices nisl sed eleifend consequat.",
      image: "assets/images/team/avatar-3.jpg",
    },

    {
      title: "John Doe",
      subTitle: "CEO / Founder",
      description: "Quisque hendrerit turpis sit amet tortor condimentum, nec commodo lorem condimentum. Sed id diam efficitur, mattis tellus ac, malesuada purus. In ultrices nisl sed eleifend consequat.",
      image: "assets/images/team/avatar-4.jpg",
    }

  ]

  // Owl Brand Logos
  customOptionsFour: OwlOptions = {
    loop: true,
    dots: false,
    margin:0,
    nav:false,
    autoplay:true,
    autoplaySpeed: 2000,
    navSpeed: 2000,
    items: 6,
    responsive:{
      0:{
          items:1,
      },
      600:{
          items:2,
      },
      1000:{
          items:6,
      }
    }
  }

  slideStoreFour = [
    {
      image: "assets/images/clients/1.png",
    },

    {
      image: "assets/images/clients/2.png",
    },

    {
      image: "assets/images/clients/3.png",
    },

    {
      image: "assets/images/clients/4.png",
    },

    {
      image: "assets/images/clients/5.png",
    },

    {
      image: "assets/images/clients/6.png",
    }

  ]

  // Contact Form
  formData = {
    user_name: '',
    user_email: '',
    message: ''
  };

  // EmailJS service configuration
  private serviceId = 'contact-form';  // Replace with your EmailJS Service ID
  private templateId = 'contact-form-becki';  // Replace with your EmailJS Template ID
  private publicKey = 'gObMl0a3V0Jib9k5c';  // Replace with your EmailJS Public Key

  // Method to send email on form submission
  public sendEmail(event: Event): void {
    event.preventDefault();

    // Send email using EmailJS
    emailjs.sendForm(this.serviceId, this.templateId, event.target as HTMLFormElement, this.publicKey)
      .then(
        (response: EmailJSResponseStatus) => {
          alert('Message sent successfully. Thank you, we will get back to you soon!');
          this.resetForm();
        },
        (error: EmailJSResponseStatus) => {
          console.error('Failed to send message. Error:', error.text);
          alert('Failed to send the message. Please try again later.');
        }
      );
  }

  // Method to reset the form after submission
  private resetForm(): void {
    this.formData = {
      user_name: '',
      user_email: '',
      message: ''
    };
  }

  socialMedia = [
    {
      iconClass: "fb border-radius-10",
      icon:"fa-brands fa-facebook"
    },
    {
      iconClass: "tw border-radius-10",
      icon:"fa-brands fa-x-twitter"
    },
    {
      iconClass: "be border-radius-10",
      icon:"fa-brands fa-behance"
    },
    {
      iconClass: "in border-radius-10",
      icon:"fa-brands fa-linkedin"
    },
    {
      iconClass: "yt border-radius-10",
      icon:"fa-brands fa-youtube"
    },
    {
      iconClass: "ins border-radius-10",
      icon:"fa-brands fa-instagram"
    }
  ]
}
